export default "__VITE_ASSET__DIR_xQPv__"